import React, { useState } from "react";
import { Grid, Stack, Typography, Avatar, Box, Divider } from "@mui/material";
//Icons
import { BsInfoCircleFill } from "react-icons/bs";
import { MdContactMail } from "react-icons/md";
//Srcs
import "./studentinfo.scss";
import CakeImage from "../../Assets/birthday-cake.png";
import GenderImage from "../../Assets/equality.png";
import moment from "moment";
import EmptyImage from "../../Assets/empty-image.png";

export default function ParentInfo({ detailsData }) {
  // console.log("detailsData: ", detailsData)
  return (
    <div className="student-info">
      <Box className="main-containner">
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
            <Box className="profile-container">
              <Stack
                className="profile"
                direction="row"
                justifycontent="center"
                sx={{ marginBottom: "20px" }}
              >
                <img
                  className="avater-image"
                  style={{ borderRadius: "10px" }}
                  src={
                    detailsData?.profileImg === "" ||
                    detailsData?.profileImg === undefined ||
                    detailsData?.profileImg === null
                      ? EmptyImage
                      : detailsData?.profileImg?.slice(0, 5) === "https"
                      ? detailsData?.profileImg
                      : `${process.env.React_App_VIEW_URL}${detailsData?.profileImg}`
                  }
                />
              </Stack>
              <Typography className="name-container-khmer">
                {detailsData?.lastName ? detailsData?.lastName : " "}{" "}
                {detailsData?.firstName ? detailsData?.firstName : " "}
              </Typography>
              <Typography className="name-container">
                {detailsData?.englishName ? detailsData?.englishName : ""}
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="row" spacing={4} sx={{ width: "70%" }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={GenderImage}
                        alt="Gender"
                        className="cake-img"
                      />
                    </Stack>
                    <Typography className="cake-title">
                      {detailsData?.gender ? detailsData?.gender : ""}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img src={CakeImage} alt="Gender" className="cake-img" />
                    </Stack>

                    <Typography className="cake-title">
                      {detailsData?.dob
                        ? moment(detailsData?.dob).format("DD-MMM-YYYY")
                        : ""}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
            <Box className="details-container">
              <Grid container spacing={3}>
                {/* =============================== father details =========================== */}
                <Grid item xs={6} sm={6} md={12} lg={12} xl={6}>
                  <Stack direction="row" spacing={1.5}>
                    <BsInfoCircleFill className="details-icon" />
                    <Typography className="details-title">Father </Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Last name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.lastName
                          ? detailsData?.father?.lastName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        First name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.firstName
                          ? detailsData?.father?.firstName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        English name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.englishName
                          ? detailsData?.father?.englishName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Date of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.dob
                          ? moment(detailsData?.father?.dob).format(
                              "DD-MMM-YYYY"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Age</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.dob
                          ? moment().diff(
                              moment(detailsData?.father?.dob),
                              "years"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Gender</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.gender
                          ? detailsData?.father?.gender
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Nationality
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.nationality
                          ? detailsData?.father?.nationality
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Tel</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.tel
                          ? detailsData?.father?.tel
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Facebook</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.tel
                          ? detailsData?.father?.social
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Place of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.village
                          ? detailsData?.father?.village + ", "
                          : ""}
                        {detailsData?.father?.commune
                          ? detailsData?.father?.commune + ", "
                          : " "}
                        {detailsData?.father?.district
                          ? detailsData?.father?.district + ", "
                          : " "}
                        {detailsData?.father?.province
                          ? detailsData?.father?.province
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Permanent address
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.permanentVillage
                          ? detailsData?.father?.permanentVillage + ", "
                          : " "}
                        {detailsData?.father?.permanentCommune
                          ? detailsData?.father?.permanentCommune + ", "
                          : " "}
                        {detailsData?.father?.permanentDistrict
                          ? detailsData?.father?.permanentDistrict + ", "
                          : " "}
                        {detailsData?.father?.permanentProvince
                          ? detailsData?.father?.permanentProvince + ", "
                          : " "}
                        {detailsData?.father?.permanentCountry
                          ? detailsData?.father?.permanentCountry
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Occupation
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.occupation
                          ? detailsData?.father?.occupation
                          : " "}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                {/* =============================== mother details =========================== */}
                <Grid item xs={6} sm={6} md={12} lg={12} xl={6}>
                  <Stack direction="row" spacing={1.5}>
                    <BsInfoCircleFill className="details-icon" />
                    <Typography className="details-title">Mother</Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Last name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.lastName
                          ? detailsData?.mother?.lastName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        First name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.firstName
                          ? detailsData?.mother?.firstName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        English name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.englishName
                          ? detailsData?.mother?.englishName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Date of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.dob
                          ? moment(detailsData?.mother?.dob).format(
                              "DD-MMM-YYYY"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Age</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {moment().diff(
                          moment(detailsData?.mother?.dob),
                          "years"
                        )
                          ? moment().diff(
                              moment(detailsData?.mother?.dob),
                              "years"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Gender</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.gender
                          ? detailsData?.mother?.gender
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Nationality
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.nationality
                          ? detailsData?.mother?.nationality
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Tel</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.tel
                          ? detailsData?.mother?.tel
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Facebook</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.tel
                          ? detailsData?.mother?.social
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Place of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.village
                          ? detailsData?.mother?.village + ", "
                          : " "}
                        {detailsData?.mother?.commune
                          ? detailsData?.mother?.commune + ", "
                          : " "}
                        {detailsData?.mother?.district
                          ? detailsData?.mother?.district + ", "
                          : " "}
                        {detailsData?.mother?.province
                          ? detailsData?.mother?.province
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Permanent address
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.mother?.permanentVillage
                          ? detailsData?.mother?.permanentVillage + ", "
                          : " "}
                        {detailsData?.mother?.permanentCommune
                          ? detailsData?.mother?.permanentCommune + ", "
                          : " "}
                        {detailsData?.mother?.permanentDistrict
                          ? detailsData?.mother?.permanentDistrict + ", "
                          : " "}
                        {detailsData?.mother?.permanentProvince
                          ? detailsData?.mother?.permanentProvince + ", "
                          : " "}
                        {detailsData?.mother?.permanentCountry
                          ? detailsData?.mother?.permanentCountry
                          : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Occupation
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.occupation
                          ? detailsData?.father?.occupation
                          : " "}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
